module.exports = __webpack_public_path__ + "img/10.1ba23b66.svg";